import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../services/customer.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DispatchService } from '../../../services/dispatch.service';
import { GlobalsService } from '../../../services/globals.service';
import { GeneralLedgerService } from '../../../services/general-ledger.service';

import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import {
	countIdDigits,
	shouldApplyTaxRefFilter,
	taxRefAltDigitsFromConfig,
	taxRefMinDigitsFromConfig,
	taxRefValidatorsForAdd,
	taxRefValidatorsForTaxable,
} from '../shipto-tax-ref-config';

declare let $: any;

@Component({
	selector: 'app-customer-shipto-add',
	templateUrl: './customer-shipto-add.component.html',
	styleUrls: ['./customer-shipto-add.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(300, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('300ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class CustomerShiptoAddComponent implements OnInit {
	@Input() customerdata;
	@Output() editing = new EventEmitter < boolean > ();
	@Output() newcustomerdata = new EventEmitter < boolean > ();

	branchForm: any = false;
	taxes: any = [];
	alltaxes: any = [];
	currencies: any = [];
	locations: any = [];
	salesman: any = [];

	shipvia: any = [];
	zones: any = [];
	areas: any;
	territories: any = [];
	status_msg = '';
	disabledbranch = false;
	tirefee = false;
	defaultbranchcustomer = true;
	paymentmethods: any = [];
	busPostingGroups: { code: string; name: string }[] = [];

	defaults = {
		country: 'United States',
		region: 'NY',
		holdreason: '1',
		currency: 'USD',
		terms: '1',
		salestype: 'A1',
		customertype: '1',
		discount: 0,
		credit: 1000,
		email_invoice: false,
		requirepo: false,
		email_statement: false,
		interest: 3,
		warehouse: '01',
		shipvia: '1',
		area: '01',
		territory: '01',
		salesman: '01',
		disabled: false,
		tirefee: true,
		taxauth: '119',
		branchcode: '00',
	};

	formEditAllowed = [
		'debtorno',
		'branchcode',
		'brname',
		'contactname',
		'braddress1',
		'braddress2',
		'braddress3',
		'braddress4',
		'braddress5',
		'braddress6',
		'email',
		'phoneno',
		'faxno',
		'specialinstructions',
		'defaultlocation',
		'defaultshipvia',
		'tax_ref',
		'taxgroupid',
		'area',
		'salesman',
		'disabletrans',
		'tirefee',
		'default_paymentmehod',
		'route',
		'cosm_license',
		'licExpDate',

		//'contactname'
	]
	routes: any = [];
	config: any = false;
	constructor(private globalSearchService: GlobalSearchService, private dispatchService: DispatchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService, public customerService: CustomerService, private generalLedgerService: GeneralLedgerService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.dispatchService.getRoutes().subscribe((r: any) => {
			this.routes = r
		});


		this.globalsService.getTaxes().subscribe(details => {
			this.taxes = details;
			this.alltaxes = details;
		});

		this.globalsService.getLocations().subscribe(details => {
			this.locations = details;
		});

		this.globalsService.getDefaultZones().subscribe(details => {
			this.zones = details;
		});

		this.globalsService.getAreas().subscribe(details => {
			this.areas = details;
		});

		this.globalsService.getTerritories().subscribe((details: any) => {
			this.territories = details;
		});

		this.globalsService.getSalesman().subscribe(details => {
			this.salesman = details;
		});

		this.globalsService.getShipVia().subscribe(details => {
			this.shipvia = details;
		});

		this.globalsService.getPaymentMethods().subscribe(details => {
			this.paymentmethods = details;
		});

	}

	/** Clients whose customers are taxed by cannabis excise, not county retail sales tax. */
	isCannabisTaxClient(): boolean {
		const client = this.config?.env?.client;
		return client === 'moov' || client === 'moov_sandbox';
	}

	ngOnInit(): void {
		this.generalLedgerService.fetchGeneralPostingBusGroups().subscribe((r: any) => {
			this.busPostingGroups = Array.isArray(r.groups) ? r.groups : [];
		}, () => {
			this.busPostingGroups = [];
		});

		const minDig = taxRefMinDigitsFromConfig(this.globalSearchService.config);
		const altDig = taxRefAltDigitsFromConfig(this.globalSearchService.config);

		this.branchForm = this.fb.group({
			debtorno: [this.customerdata.customer.debtorno, [Validators.required]],
			branchcode: [this.nextBranch(this.customerdata.branches.length), [Validators.required]],
			brname: [this.customerdata.customer.name, [Validators.required]],
			contactname: [this.customerdata.customer.contactname, [Validators.required]],
			braddress1: ['', [Validators.required]],
			braddress2: [''],
			braddress3: ['', [Validators.required]],
			braddress4: [this.customerdata.customer.address4, [Validators.required]],
			braddress5: ['', [Validators.required]],
			braddress6: [this.customerdata.customer.address6, [Validators.required]],
			//estdeliverydays: [''],
			phoneno: [this.customerdata.customer.phoneno],
			email: [this.customerdata.customer.email],
			faxno: [this.customerdata.customer.faxno],
			disabletrans: [this.defaults.disabled],
			tirefee: [this.defaults.tirefee, [Validators.required]],
			defaultlocation: [this.defaults.warehouse, [Validators.required]],
			defaultshipvia: [this.defaults.shipvia, [Validators.required]],
			area: [this.defaults.area, [Validators.required]],
			territory_id: ['0'],
			salesman: [this.defaults.salesman, [Validators.required]],
			tax_ref: [this.customerdata.customer.tax_ref, taxRefValidatorsForAdd(minDig, altDig)],
			taxgroupid: [this.defaults.taxauth, [Validators.required]],
			specialinstructions: [this.customerdata.customer.specialinstructions],
			default_paymentmehod: [this.customerdata.customer.default_paymentmehod],
			route: [this.customerdata.customer.route, [Validators.required]],
			licExpDate: [this.customerdata.customer.licExpDate],
			cosm_license: [this.customerdata.customer.cosm_license],
			signed_mor: [this.customerdata.customer.signed_mor],
		gen_bus_posting_group: [''],

		});


		this.branchForm.markAllAsTouched();

		this.branchForm.get('braddress5').valueChanges.subscribe(newValue => {
			// See customer-create.component.ts: on Moov the zip->county lookup can only return
			// retail sales-tax groups, which is never correct for wholesale cannabis.
			if (this.isCannabisTaxClient()) {
				this.taxes = this.alltaxes;
				return;
			}
			const data_search  = {
				zipcode: newValue
			}
			this.customerService.zipCodeCheck(data_search).subscribe(async (results: any) => {
				if(results && results.length) {
					this.taxes = results;
					this.branchForm.get('taxgroupid').setValue(results[0].taxgroupid)
				} else {
					this.taxes = this.alltaxes;
				}
			});
		});

		this.branchForm.get('tax_ref').valueChanges.subscribe((newvalue) => {
			let currentValue = this.alltaxes.filter((v) => {
				return v.taxgroupid == this.branchForm.get('taxgroupid').value;
			})[0];

			if (currentValue) {
				currentValue = currentValue.taxgroupdescription;
			} else {
				currentValue = '';
			}

			if (shouldApplyTaxRefFilter(newvalue, minDig, altDig)) {
				this.filterTaxAuths(true, currentValue);
			} else {
				this.filterTaxAuths(false, currentValue);
			}
		});

		const updateTaxRefValidators = (taxgroupid: any) => {
			const taxgroup = this.alltaxes.find((t: any) => t.taxgroupid == taxgroupid);
			const desc: string = taxgroup ? taxgroup.taxgroupdescription : '';
			const taxRefCtrl = this.branchForm.get('tax_ref');
			if (desc.startsWith('1')) {
				taxRefCtrl.setValidators(taxRefValidatorsForTaxable());
			} else {
				taxRefCtrl.setValidators(taxRefValidatorsForAdd(minDig, altDig));
			}
			taxRefCtrl.updateValueAndValidity({ emitEvent: false });
		};

		this.branchForm.get('taxgroupid').valueChanges.subscribe(updateTaxRefValidators);
		updateTaxRefValidators(this.branchForm.get('taxgroupid').value);
	}

	taxRefMinDigits(): number | null {
		return taxRefMinDigitsFromConfig(this.globalSearchService.config);
	}

	taxRefHintText(): string {
		const ctrl = this.branchForm?.get('tax_ref');
		if (!ctrl?.errors) {
			return '';
		}
		const minD = this.taxRefMinDigits();
		if (minD != null && ctrl.errors['taxRefMinDigits']) {
			const act = countIdDigits(ctrl.value);
			const altD: number[] = ctrl.errors['taxRefMinDigits'].altDigits || [];
			const altText = altD.length ? ` or exactly ${altD.join('/')}` : '';
			return `${act}/${minD} digits (minimum ${minD}${altText})`;
		}
		if (ctrl.errors['minlength']) {
			const req = ctrl.errors['minlength'].requiredLength;
			const act = ctrl.value != null ? String(ctrl.value).length : 0;
			return `${act}/${req} characters`;
		}
		return '';
	}

	filterTaxAuths(filter: any, current: any) {

		if (filter) {

			const results = this.taxes.filter((r: any) => {
				let newvalue = '';

				if (current != '') {
					newvalue = current.replace('1', '2');
				}

				if (r.taxgroupdescription.startsWith('2')) {
					if (newvalue != '' && newvalue == r.taxgroupdescription) {
						this.branchForm.get('taxgroupid').setValue(r.taxgroupid);
						//this.globalSearchService.showNotification('Tax Group Updated to Non Taxable', 'warn', 'bottom', 'right');
					}
					return r;
				}
			})
			this.taxes = results;
		} else {
			this.taxes = this.alltaxes;
		}
	}

	nextBranch(count: any) {
		//count = count+1; - no need qantel started at zero
		let stringbranch = ''
		if (parseFloat(count) < 10) {
			stringbranch += '0' + count
		} else {
			stringbranch = count;
		}

		return stringbranch;
	}

	ngAfterViewInit() {


	}

	createCustomer() {

		if (this.branchForm.valid) {
			this.customerService.updateBranch(this.branchForm.value).subscribe(details => {
				if (details.success) {
					this.newcustomerdata.emit(this.branchForm.value);
					//this.showNotification(this.status_msg,'success','bottom','right');
				} else {
					//this.showNotification(this.status_msg,'danger','bottom','right');
				}
			});
		} else {
			this.globalSearchService.getFormValidationErrors(this.branchForm);
		}
	}
	updateZones(input: any) {

	}

}
